<template>
  <div
    @mouseleave="
      () => {
        handleCloseNavigation()
        handleCloseSearch()
      }
    "
  >
    <div class="bg-black z-40 relative">
      <BaseContainer>
        <div
          class="h-12 md:h-[77px] flex items-center justify-between relative"
        >
          <div class="flex items-center gap-x-2">
            <div
              class="xl:hidden fill-primary-white hover:opacity-50 cursor-pointer text-primary-white"
              @click="isOpen = !isOpen"
            >
              <Icon name="bars" />
            </div>
            <NuxtLinkLocale
              to="/"
              aria-label="Home Page"
              @click="
                () => {
                  handleCloseNavigation()
                }
              "
            >
              <SvgCaseClubLogo />
            </NuxtLinkLocale>
          </div>
          <div
            class="hidden xl:flex justify-center items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[77px]"
            @mouseleave="
              () => {
                handleCloseNavigation()
                // handleCloseSearch()
              }
            "
          >
            <div class="flex">
              <NuxtLinkLocale
                v-for="navigationItem in newNavigation"
                :key="navigationItem.title"
                :to="navigationItem.url"
                :class="
                  twJoin(
                    'flex items-center px-3 text-xl text-primary-white font-medium cursor-pointer whitespace-nowrap',
                    `relative before:content-[''] before:absolute before:w-0 before:h-[1px] before:bg-primary-white hover:before:w-[calc(100%-24px)] before:right-3 hover:before:left-3 before:translate-y-4 before:transition-all before:ease`,
                    isOpen &&
                      page == navigationItem.page &&
                      'before:w-[calc(100%-24px)]'
                  )
                "
                @mouseenter="() => handleOpenNavigation(navigationItem.page)"
                @click="handleCloseNavigation"
              >
                {{ navigationItem.title }}
              </NuxtLinkLocale>
              <NuxtLinkLocale
                to="/blogs"
                :class="
                  twJoin(
                    'flex items-center px-3 text-xl text-primary-white font-medium cursor-pointer whitespace-nowrap',
                    `relative before:content-[''] before:absolute before:w-0 before:h-[1px] before:bg-primary-white hover:before:w-[calc(100%-24px)] before:right-3 hover:before:left-3 before:translate-y-4 before:transition-all before:ease`,
                    isOpen &&
                      page == $t('pages.blogs.expore') &&
                      'before:w-[calc(100%-24px)]'
                  )
                "
                @mouseenter="
                  () => {
                    isOpen = false
                    isSearch = false
                    page = $t('pages.blogs.expore')
                  }
                "
              >
                {{ $t('pages.blogs.expore') }}
              </NuxtLinkLocale>
            </div>
          </div>
          <div
            class="text-primary-white fill-primary-white flex items-center space-x-6"
          >
            <div class="flex items-center space-x-1 md:space-x-4">
              <div
                class="hover:opacity-50 cursor-pointer"
                @click="
                  () => {
                    isSearch = !isSearch
                    isOpen = false
                  }
                "
              >
                <Icon name="magnifying-glass" />
              </div>
              <NuxtLinkLocale
                aria-label="Account"
                :to="user ? '/account' : '/sign-up'"
                class="hover:opacity-50 cursor-pointer flex items-center gap-x-1"
                @click="isOpen = false"
              >
                <Icon name="user" />
                <div
                  class="max-w-[30px] md:max-w-[90px] xl:max-w-[60px] truncate"
                >
                  {{ user?.first_name }}
                </div>
              </NuxtLinkLocale>
              <div
                class="hover:opacity-50 cursor-pointer relative"
                @click="openCart"
              >
                <Icon name="shopping-cart" />

                <div
                  v-if="itemsInCart.length > 0"
                  class="absolute top-0 right-0 bg-primary-tangerine w-4 h-4 rounded-full flex items-center justify-center px-1 py-1 text-xxs translate-x-1/4 -translate-y-1/4"
                >
                  {{
                    itemsInCart.reduce((acc, item) => {
                      return acc + item?.quantity
                    }, 0)
                  }}
                </div>
              </div>
            </div>
            <div class="hidden xl:flex items-center space-x-3">
              <div
                :class="
                  twJoin(
                    'text-xl cursor-pointer hover:opacity-50',
                    locale !== 'en' && 'text-typo-muted'
                  )
                "
                @click="() => handleChangeLanguage('en')"
              >
                EN
              </div>
              <div class="h-4 w-[1px] bg-primary-white" />
              <div
                :class="
                  twJoin(
                    'text-xl cursor-pointer hover:opacity-50',
                    locale !== 'th' && 'text-typo-muted'
                  )
                "
                @click="() => handleChangeLanguage('th')"
              >
                ไทย
              </div>
            </div>
          </div>
        </div>
      </BaseContainer>
    </div>
    <div
      v-show="isSearch"
      @mouseenter="isSearch = true"
      @mouseleave="() => handleCloseSearch()"
    >
      <TopbarSearch
        :is-search="isSearch"
        @submit="
          () => {
            handleCloseNavigation()
            handleCloseSearch()
          }
        "
      />
    </div>
    <div
      v-show="isOpen || isSearch"
      class="bg-black w-screen h-screen fixed top-0 z-30 opacity-80"
      @mouseenter="
        () => {
          handleCloseNavigation()
        }
      "
    />
    <div
      v-show="isOpen"
      class="bg-primary-white absolute z-30 w-full overflow-auto xl:max-h-[calc(100vh-121px)]"
      @mouseenter="() => handleOpenNavigation(page)"
    >
      <div class="block xl:hidden">
        <MainNavigationListItemMobile
          :menu="[
            newDeviceMenu,
            newStyleMenu,
            newCollabMenu,
            newPersonalizationMenu,
            newProductMenu
          ]"
          @close="handleCloseNavigation"
        />
      </div>
      <BaseContainer class="hidden xl:block">
        <MainNavigationListItem
          v-show="page == slug(newDeviceMenu.url)"
          :menu="newDeviceMenu"
          @close="handleCloseNavigation"
        />
        <MainNavigationListItem
          v-show="page == slug(newStyleMenu.url)"
          :menu="newStyleMenu"
          @close="handleCloseNavigation"
        />
        <MainNavigationListItem
          v-show="page == slug(newCollabMenu.url)"
          :menu="newCollabMenu"
          @close="handleCloseNavigation"
        />
        <MainNavigationListItem
          v-show="page == slug(newPersonalizationMenu.url)"
          :menu="newPersonalizationMenu"
          @close="handleCloseNavigation"
        />
        <MainNavigationListItem
          v-show="page == slug(newProductMenu.url)"
          :menu="newProductMenu"
          @close="handleCloseNavigation"
        />
      </BaseContainer>
    </div>
  </div>
</template>

<script lang="ts" setup>
import scrollLock from 'scroll-lock'
import slug from 'slug'
import { twJoin } from 'tailwind-merge'
import { cmsRepository } from '~/repository/cmsRepository'
const { locale, setLocale } = useI18n()
const { width } = useWindowSize()

const isOpen = ref<boolean>(false)
const isSearch = ref<boolean>(false)
const page = ref<string>('devices')
const { openCart } = useWebsiteStoreV2()
const cartStore = useCartStoreV2()
const { items: itemsInCart } = storeToRefs(cartStore)

const userStore = useUserStore()
const { user } = storeToRefs(userStore)

const handleOpenNavigation = (nextPage: string) => {
  isOpen.value = true
  isSearch.value = false
  page.value = nextPage
  // scrollLock.disablePageScroll()
}

const handleCloseNavigation = () => {
  width.value >= 1280
    ? (isOpen.value = false)
    : setTimeout(() => {
        isOpen.value = false
      }, 1200)
  scrollLock.enablePageScroll()
}

const handleCloseSearch = () => {
  isSearch.value = false
  scrollLock.enablePageScroll()
}

const handleChangeLanguage = (lang: string) => {
  setLocale(lang)
}

// const config = useRuntimeConfig()
// const isProduction = config.public.siteUrl === 'https://caseclub.in.th'

const { $serverApi } = useNuxtApp()
const cmsRepo = cmsRepository($serverApi)

const { data: pageData } = await useAsyncData<
  {
    titleEn: string
    titleTh: string
    href: string
    type: 'ListMenu' | 'BlockMenu'
    listMenuTitleEn: string
    listMenuTitleTh: string
    listMenu: {
      titleEn: string
      titleTh: string
      menus: {
        titleEn: string
        titleTh: string
        footerTitleMenuEn: string
        footerTitleMenuTh: string
        footerMenuHref: string
        items: {
          imageUrl?: string
          descriptionEn?: string
          descriptionTh?: string
          linkTitleEn?: string
          linkTitleTh?: string
          titleEn: string
          titleTh: string
          href: string
        }[]
      }[]
      cards: {
        titleEn: string
        titleTh: string
        footerTitleMenuEn?: string
        footerTitleMenuTh?: string
        footerMenuHref?: string
        items: {
          imageUrl?: string
          titleEn: string
          titleTh: string
          href: string
        }[]
      }[]
    }[]
  }[]
>('getNavigation', async () => {
  const response = await cmsRepo.getWidget('navigation')
  if (response.data.data.items[0]) return response.data.data.items[0]
  return null
})

const newNavigation = computed(() => {
  return (
    pageData.value?.map((item) => ({
      title:
        locale.value === 'en' ? item.titleEn : item.titleTh || item.titleEn,
      page: slug(item.href),
      url: item.href
    })) || []
  )
})

// const navigation = computed<NavigationType>(() => [
//   {
//     title: t('navigation.devices'),
//     page: 'devices',
//     url: '/devices'
//   },
//   {
//     title: t('navigation.styles'),
//     page: 'styles',
//     url: '/styles'
//   },
//   {
//     title: t('navigation.collabs'),
//     page: 'collabs',
//     url: '/collabs'
//   },
//   {
//     title: t('navigation.personalization'),
//     page: 'personalization',
//     url: '/personalization'
//   },
//   {
//     title: t('navigation.products'),
//     page: 'products',
//     url: '/products'
//   }
// ])

const getMenus = (
  menuData:
    | {
        titleEn: string
        titleTh: string
        href: string
        type: 'ListMenu' | 'BlockMenu'
        listMenuTitleEn: string
        listMenuTitleTh: string
        listMenu: {
          titleEn: string
          titleTh: string
          menus: {
            titleEn: string
            titleTh: string
            footerTitleMenuEn: string
            footerTitleMenuTh: string
            footerMenuHref: string
            items: {
              imageUrl?: string
              descriptionEn?: string
              descriptionTh?: string
              linkTitleEn?: string
              linkTitleTh?: string
              titleEn: string
              titleTh: string
              href: string
            }[]
          }[]
          cards: {
            titleEn: string
            titleTh: string
            footerTitleMenuEn?: string
            footerTitleMenuTh?: string
            footerMenuHref?: string
            items: {
              imageUrl?: string
              titleEn: string
              titleTh: string
              href: string
            }[]
          }[]
        }[]
      }
    | undefined
) => {
  return {
    title:
      (locale.value === 'en'
        ? menuData?.listMenuTitleEn
        : menuData?.listMenuTitleTh || menuData?.listMenuTitleEn) || '',
    titleMobile:
      (locale.value === 'en'
        ? menuData?.titleEn
        : menuData?.titleTh || menuData?.titleEn) || '',
    url: menuData?.href || '#',
    list:
      menuData?.listMenu.map((menu) => ({
        title:
          locale.value === 'en' ? menu.titleEn : menu.titleTh || menu.titleEn,
        linkItems: menu.menus.map((item) => ({
          footerTitle:
            (locale.value === 'en'
              ? item.footerTitleMenuEn
              : item.footerTitleMenuTh || item.footerTitleMenuEn) || '',
          title:
            locale.value === 'en' ? item.titleEn : item.titleTh || item.titleEn,
          url: item.footerMenuHref,
          items: item.items.map((subItem) => ({
            imageUrl: subItem.imageUrl || '',
            title:
              (locale.value === 'en'
                ? subItem.titleEn
                : subItem.titleTh || subItem.titleEn) || '',
            url: subItem.href || '#'
          }))
        })),
        cardItems: menu.cards.map((card) => ({
          footerTitle:
            (locale.value === 'en'
              ? card.footerTitleMenuEn
              : card.footerTitleMenuTh || card.footerTitleMenuEn) || '',
          url: card.footerMenuHref,
          title:
            locale.value === 'en' ? card.titleEn : card.titleTh || card.titleEn,
          items: card.items.map((subItem) => ({
            title:
              (locale.value === 'en'
                ? subItem.titleEn
                : subItem.titleTh || subItem.titleEn) || '',
            url: subItem.href || '#',
            imageUrl: subItem.imageUrl || ''
          }))
        }))
      })) || []
  }
}

const getBlockMenus = (
  menuData:
    | {
        titleEn: string
        titleTh: string
        href: string
        type: 'ListMenu' | 'BlockMenu'
        listMenuTitleEn: string
        listMenuTitleTh: string
        listMenu: {
          titleEn: string
          titleTh: string
          menus: {
            titleEn: string
            titleTh: string
            footerTitleMenuEn: string
            footerTitleMenuTh: string
            footerMenuHref: string
            items: {
              imageUrl?: string
              descriptionEn?: string
              descriptionTh?: string
              linkTitleEn?: string
              linkTitleTh?: string
              titleEn: string
              titleTh: string
              href: string
            }[]
          }[]
          cards: {
            titleEn: string
            titleTh: string
            items: {
              imageUrl?: string
              titleEn: string
              titleTh: string
              href: string
            }[]
          }[]
        }[]
      }
    | undefined
) => {
  return {
    title:
      (locale.value === 'en'
        ? menuData?.listMenuTitleEn
        : menuData?.listMenuTitleTh || menuData?.listMenuTitleEn) || '',
    titleMobile:
      (locale.value === 'en'
        ? menuData?.titleEn
        : menuData?.titleTh || menuData?.titleEn) || '',
    url: menuData?.href || '#',
    blockItems: {
      title:
        (locale.value === 'en'
          ? menuData?.listMenu[0].titleEn
          : menuData?.listMenu[0].titleTh || menuData?.listMenu[0].titleEn) ||
        '',
      items:
        menuData?.listMenu[0].menus[0].items.map((subItem) => ({
          titleEn: subItem.titleEn || '',
          titleTh: subItem.titleTh || subItem.titleTh || '',
          imageUrl: subItem.imageUrl || '',
          descriptionEn: subItem.descriptionEn || '',
          descriptionTh: subItem.descriptionTh || subItem.descriptionEn || '',
          buttonTitle:
            (locale.value === 'en'
              ? subItem.linkTitleEn
              : subItem.linkTitleTh || subItem.linkTitleEn) || '',
          buttonUrl: subItem.href
        })) || []
    },
    list: [
      {
        title: 'Apple',
        linkItems: [],
        cardItems:
          menuData?.listMenu[0].cards.map((card) => ({
            title:
              (locale.value === 'en'
                ? card.titleEn
                : card.titleTh || card.titleEn) || '',
            items: card.items.map((subItem) => ({
              title:
                (locale.value === 'en'
                  ? subItem.titleEn
                  : subItem.titleTh || subItem.titleEn) || '',
              url: subItem.href,
              imageUrl: subItem.imageUrl || ''
            }))
          })) || []
      }
    ]
  }
}

const newDeviceMenu = computed(() =>
  getMenus(pageData.value?.find((item) => item.href === '/devices'))
)

const newStyleMenu = computed(() =>
  getMenus(pageData.value?.find((item) => item.href === '/all-styles'))
)

const newCollabMenu = computed(() =>
  getMenus(pageData.value?.find((item) => item.href === '/collabs'))
)

const newPersonalizationMenu = computed(() =>
  getBlockMenus(
    pageData.value?.find((item) => item.href === '/personalization')
  )
)

const newProductMenu = computed(() =>
  getMenus(pageData.value?.find((item) => item.href === '/products'))
)
</script>
